import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { usePermissions } from "../hooks/usePermissions";
import { LoadingSpinner } from "../components/LoadingSpinner";

export function PlatformAdminRoute() {
  const { isLoading } = useAuth();
  const { isAuthenticated, isPlatformAdmin } = usePermissions();

  if (isLoading) {
    return <LoadingSpinner message="Checking permissions..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isPlatformAdmin) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
